<div class="fresh-ui m-padding-card">
    <div class="new-video-post-card">
        <div class="video-post-thumbnail position-relative"
            (click)="GoToPreviewCard(card)">
            <div class="badge-video">
                Card
            </div>
            <img *ngIf="card?.ThumbnailImage && card?.ThumbnailImage.length"
                width="100%" height="100%"
                src="{{httpService.baseURL}}{{card?.ThumbnailImage}}"
                class="t-image"
                [alt]="card?.NameEnglish">
        </div>
        <div class="video-post-content">
            <h3 class="heading cursor-pointer general_sans">
                <a
                    [routerLink]="'/preview/'+card.NameEnglish+'/card' |
                formateUrl:'cardId=' + card?.CardId+'&categoryId='+
                card?.CategoryId + '&subCategoryId=' +
                card?.SubCategoryId" target="_blank">{{card.NameEnglish}}</a>
            </h3>
        </div>
    </div>
</div>